import { CurrentUser, UserRole, UserService } from '@/routing/UserService';
import { User } from 'firebase';

export class FirebaseUserService implements UserService {
  private static async resolveToken(currentUser: User | null) {
    if (!currentUser) {
      return null;
    }
    return await currentUser.getIdTokenResult();
  }

  private static resolveRole(tokenResult: firebase.auth.IdTokenResult | null) {
    if (!tokenResult) {
      return UserRole.LOGGED_OUT;
    }

    if (tokenResult.claims.clientAdmin) {
      return UserRole.CLIENT_ADMIN;
    }

    return UserRole.HOLISTIC_ADMIN;
  }

  private static resolveClientId(
    tokenResult: firebase.auth.IdTokenResult | null,
  ) {
    return tokenResult ? tokenResult.claims.clientId : undefined;
  }

  public constructor(private readonly auth: firebase.auth.Auth) {}

  public async resolve(): Promise<CurrentUser> {
    const tokenResult = await FirebaseUserService.resolveToken(
      this.auth.currentUser,
    );
    const role = FirebaseUserService.resolveRole(tokenResult);
    const clientId = FirebaseUserService.resolveClientId(tokenResult);
    return {
      clientId,
      role,
    };
  }
}
